/**
 * Created with IntelliJ IDEA.
 * @author: ArvinChen9539
 * Date: 2021/9/14
 * Time: 16:11
 * Description:
 */
import "./scss/timeline.scss";
// @ts-ignore
import timeline from './js/timeline.js';
export default timeline;
